

















































import GiftChoice from './gift-choice/gift-choice'
import LineItem from './line-item'
import CartCosts from './cart-costs'
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'

export default

	components: {
		GiftChoice
		LineItem
		CartCosts
	}

	computed:

		# Vuex accessors
		cart: -> @$store.state.cart
		lineItems: ->@$store.state.cart.lines
		hasItems: -> @$store.getters['cart/itemCount'] > 0
		checkoutUrl: -> @cart.checkoutUrl

		# Make the string containing the cart count
		cartCount: ->
			count = @$store.getters['cart/itemCount']
			"#{count} #{if count == 1 then 'ITEM' else 'ITEMS'}"

	watch:

		# Enable body scroll lock when open and close
		'cart.open': (open) ->
			if open then @$defer =>
				disableBodyScroll @$refs.lines
				html = document.querySelector 'html'
				html.style.height = '100vh'
			else
				clearAllBodyScrollLocks()
				html = document.querySelector 'html'
				html.style.height = ''

	methods:

		closeCart: -> @$store.commit 'cart/close'

		# Fire checkout click GTM event
		onCheckout: ->
			payload = await @$gtmEcomm.getSimplifiedCheckout @$store.state.cart.id
			@$gtm.push { event: 'Checkout Clicked', ...payload }

